var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.414,
    height: 14.965,
    viewBox: "0 0 18.414 14.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M5.873,11.141A10.676,10.676,0,0,0,16.622.392q0-.245-.011-.488A7.688,7.688,0,0,0,18.5-2.053a7.537,7.537,0,0,1-2.169.595,3.792,3.792,0,0,0,1.661-2.09,7.577,7.577,0,0,1-2.4.917A3.774,3.774,0,0,0,12.83-3.824,3.778,3.778,0,0,0,9.052-.047a3.774,3.774,0,0,0,.1.861A10.726,10.726,0,0,1,1.363-3.132a3.769,3.769,0,0,0-.511,1.9A3.775,3.775,0,0,0,2.533,1.911,3.748,3.748,0,0,1,.822,1.439c0,.016,0,.031,0,.048a3.779,3.779,0,0,0,3.031,3.7,3.792,3.792,0,0,1-1,.133,3.755,3.755,0,0,1-.71-.068A3.782,3.782,0,0,0,5.675,7.879,7.579,7.579,0,0,1,.983,9.5a7.689,7.689,0,0,1-.9-.052,10.694,10.694,0,0,0,5.791,1.7",
    transform: "translate(-0.082 3.824)",
    fill: "#c2c2c2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d20acb05bcc88f603af3318e24ecd0ce.svg";
export { ForwardRef as ReactComponent };